import { memoize, minBy } from 'lodash';
const buildComponentTree = memoize((ds, componentRef) => {
    const connection = ds.platform.controllers.connections.getPrimaryConnection(componentRef);
    return {
        componentRef,
        role: connection?.role,
        children: ds.deprecatedOldBadPerformanceApis.components
            .getChildren(componentRef)
            .map((c) => buildComponentTree(ds, c)),
    };
}, (_ds, compRef) => compRef.id);
export const findComponentBySelectorInternal = (item, selectors, nestingLevel = 0) => {
    const topSelector = selectors[0];
    if (!topSelector) {
        return [];
    }
    if (topSelector === item.role) {
        selectors.shift();
    }
    if (selectors.length === 0) {
        return [{ item, nestingLevel }];
    }
    if (!item.children?.length) {
        return [];
    }
    const childResults = item.children?.map((child) => {
        return findComponentBySelectorInternal(child, selectors.slice(), nestingLevel++);
    });
    return childResults.flatMap((x) => x);
};
export const findComponentBySelector = (ds, rootCompRef, selector) => {
    const roles = selector
        .split(' ')
        .map((x) => x.trim())
        .map((x) => x.slice(1));
    const componentTree = buildComponentTree(ds, rootCompRef);
    const foundElements = findComponentBySelectorInternal(componentTree, roles);
    return minBy(foundElements, (x) => x.nestingLevel)?.item;
};
//# sourceMappingURL=helpers.js.map